import { toast } from "react-toastify";
import FetchAPI from "../../../api/FetchAPI";
import {
  FailureProvisionedAppListAction,
  FetchProvisionedAppListAction,
  FirstPageAction,
  NextPageAction,
  ProvisionedAppType,
  ReceiveProvisionedAppListAction,
  ToggleHiddenRegionAction,
  ToggleViewMoreAction,
} from "../types";
import {
  MARKETPLACE_PROVISIONED_APPS_TOGGLE_VIEWMORE,
  MARKETPLACE_PROVISIONED_APPS_FIRST_PAGE,
  MARKETPLACE_PROVISIONED_APPS_NEXT_PAGE,
  MARKETPLACE_PROVISIONED_APPS_TOGGLE_HIDDEN_REGION,
  MARKETPLACE_PROVISIONED_APPS_FAILURE,
  MARKETPLACE_PROVISIONED_APPS_RECEIVE,
  MARKETPLACE_PROVISIONED_APPS_FETCH,
  MARKETPLACE_PROVISIONED_APP_DELETE_STARTED,
  MARKETPLACE_PROVISIONED_APP_DELETE_FAILED,
} from "./constant";
import {
  toastError,
  toastMultipleResults,
} from "../../../app_shared_functions";
import { Dispatch } from "redux";
import { State } from "../../../selectors/state";
import { getStackNameFromResource } from "../../helper";

export const fetchProvisionedAppList = (): FetchProvisionedAppListAction => ({
  type: MARKETPLACE_PROVISIONED_APPS_FETCH,
});

export const receiveProvisionedAppList = (
  data: any,
): ReceiveProvisionedAppListAction => ({
  type: MARKETPLACE_PROVISIONED_APPS_RECEIVE,
  payload: data,
});

export const failureProvisionedAppList = (
  error: string,
): FailureProvisionedAppListAction => ({
  type: MARKETPLACE_PROVISIONED_APPS_FAILURE,
  payload: error,
});

export const toggleViewMore = (data: any): ToggleViewMoreAction => ({
  type: MARKETPLACE_PROVISIONED_APPS_TOGGLE_VIEWMORE,
  payload: data,
});

export const toggleHiddenRegion = (
  region: string,
): ToggleHiddenRegionAction => ({
  type: MARKETPLACE_PROVISIONED_APPS_TOGGLE_HIDDEN_REGION,
  payload: region,
});

export const nextPage = (): NextPageAction => ({
  type: MARKETPLACE_PROVISIONED_APPS_NEXT_PAGE,
});

export const firstPage = (): FirstPageAction => ({
  type: MARKETPLACE_PROVISIONED_APPS_FIRST_PAGE,
});

export const deleteProvisionedApp =
  (resource: ProvisionedAppType) =>
  (dispatch: Dispatch, getState: () => State) => {
    if (!resource) return false;

    const { orchestration_stacks } = getState();
    const orchestrationStacks =
      orchestration_stacks?.ORCHESTRATION_STACKS_LIST as
        | Record<string, any>
        | undefined;

    const stackName = getStackNameFromResource(resource, orchestrationStacks);

    return FetchAPI.Marketplace.deleteProvisionedApp(
      resource.projectId,
      resource.regionTag,
      resource.id,
      stackName,
    )
      .then((response) => {
        if (response && response.status === 204) {
          dispatch({
            type: MARKETPLACE_PROVISIONED_APP_DELETE_STARTED,
            payload: { id: resource.id },
          });
          toast.success("Provisioned App Delete in progress.");
        }
      })
      .catch((err) => {
        dispatch({
          type: MARKETPLACE_PROVISIONED_APP_DELETE_FAILED,
          payload: {
            id: resource.id,
            error: err.message || "Deleting provisioned app failed",
          },
        });
        toastError(err, "Deleting provisioned app failed.");
      });
  };

export const deleteMultipleProvisionedApps =
  (resources: ProvisionedAppType[]) =>
  (dispatch: Dispatch, getState: () => State) => {
    if (resources.length === 0) return false;
    toast.success(
      `About to delete ${resources.length} Provisioned App${resources.length > 1 ? "s" : ""}...`,
    );
    const { orchestration_stacks } = getState();
    const orchestrationStacks =
      orchestration_stacks?.ORCHESTRATION_STACKS_LIST as
        | Record<string, any>
        | undefined;

    const promises = resources.map((resource) => {
      const stackName = getStackNameFromResource(resource, orchestrationStacks);
      return new Promise((resolve) => {
        FetchAPI.Marketplace.deleteProvisionedApp(
          resource.projectId,
          resource.regionTag,
          resource.id,
          stackName,
        )
          .then((response) => {
            if (response && response.status === 204) {
              dispatch({
                type: MARKETPLACE_PROVISIONED_APP_DELETE_STARTED,
                payload: { id: resource.id },
              });
              resolve({ status: "resolved", id: resource.id });
            }
          })
          .catch((err) => {
            dispatch({
              type: MARKETPLACE_PROVISIONED_APP_DELETE_FAILED,
              payload: {
                id: resource.id,
                error: err.message || "Deleting provisioned app failed",
              },
            });
            resolve({
              status: "rejected",
              id: resource.id,
              desc: err.message || "Deleting provisioned app failed",
            });
          });
      });
    });

    Promise.all(promises).then((responses) =>
      toastMultipleResults({
        responses,
        resource_name: "provisioned app",
        action: "delete",
        dispatch,
      }),
    );
  };
